import { useQuery } from '@tanstack/react-query';
import { IDriveContent } from 'src/@types/drive';
import { DriveRequests } from 'src/requests/drive';
import { QueryKey } from 'src/utils/react-query';

export const useDriveContentPublicTokenQuery = (
  content: IDriveContent,
  currentUser?: string,
) => {
  const queryKey = [QueryKey.DRIVE, 'publicToken', content?._id];

  const { data: driveContentToken, isLoading: isDriveContentTokenLoading } =
    useQuery(
      queryKey,
      () => DriveRequests.getFileTokenById(content?._id!),

      {
        enabled: !!content?.isPublic && currentUser === content.user,
        refetchOnWindowFocus: false,
      },
    );

  return {
    driveContentToken,
    isDriveContentTokenLoading,
  };
};
